import React, { useEffect, useState } from 'react'
import DashCards from '../../component/reusable/DashCards'
import styles from "./dasboard.module.css";
import ProdTable from './ProdTable';
import OrdersChart from './OrdersChart';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProductsThunk, getDashboardStatistics, setdashboardProductPage } from '../../redux/dashboardSlice';
import { getLeafCategoryName } from '../../utils/fomateDate';


const Dashboard = () => {
  const dispatch = useDispatch()
  const { dashboard, loading, refresh, status, page } = useSelector(state => state.dashboard)
  const [limit, setLimit] = useState(2)
  const [sortBy, setSortyBy] = useState('createdAt');
  const [order, setOrder] = useState('asc')
  const products = dashboard?.outOfStockProducts
  const product = products?.products || []
  const totalPages = products?.totalPages
  const totalItems = products?.totalCount
  const itemsPerPage = products?.limit


const start = (page - 1) * limit + 1;
  const end =
    totalPages === page
      ? totalItems
      : (page - 1) * limit + limit;


  useEffect(() => {
    dispatch(getDashboardStatistics(`?page=${page}&status=${status}&limit=${limit}&sortBy=${sortBy}&order=${order}`))
  }, [])




  if (loading) {
    return (
      <div>
        Loading...
      </div>
    )
  }

  return (
    <div>
      <DashCards data={dashboard?.statistics} />
      <div className={styles.cardMain}>
        <div className={styles.cardRow}>
          <div className={styles.graph}>
            <OrdersChart graphdata={dashboard?.chartData} />
          </div>
          <div className={styles.custom}>
            <h3 className={styles.cardtitle}>Platinum Customers</h3>
            {/* <p className={styles.cardsubtitle}>Top product in a period of time</p> */}
            <div className={styles.cardscroll}>
              <ul className={styles.cardlist} >
                {dashboard?.platinumUsers?.map((customer, index) => (
                  <li key={index} className={styles.cardlistItem} >
                    <div>
                      {customer?.profileImg ?
                        <img src={customer?.profileImg} width='40px' height='40x'
                          style={{ gap: "10px", borderRadius: "50px" }} />
                        :
                        <img src='/assets/ProfilePhoto.png' width='40px' height='40x'
                          style={{ gap: "10px", borderRadius: "50px" }} />
                      }
                    </div>
                    <div>
                      <strong>{customer?.fullName}</strong>
                      <p className={styles.cardcategory}>{customer.email}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
          <div className={styles.cardCol1}>
            <div className={styles.card1}>
              <h3 className={styles.cardtitle}>Most Viewed Products</h3>
              <p className={styles.cardsubtitle}>Top product in a period of time</p>
              <div className={styles.cardscroll}>
                <ul className={styles.cardlist}>
                  {dashboard?.mostViewedProducts?.map((product, index) => (
                    <li key={index} className={styles.cardlistItem}>
                      <div>
                        <strong>{product?.productOverview?.productNumber[0] || " "}</strong>
                        <p className={styles.cardcategory}>{getLeafCategoryName(product?.categories) || " "}</p>
                      </div>
                      <div>
                        <span className={styles.cardviews}>{product.views}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className={styles.card1}>
              <h3 className={styles.cardtitle}>Most Procurred Products</h3>
              {/* <p className={styles.cardsubtitle}>Top product in a period of time</p> */}
              <div className={styles.cardscroll}>
                <ul className={styles.cardlist}>

                  {dashboard?.mostProcuredProducts?.map((product, index) => (

                    <li key={index} className={styles.cardlistItem}>
                      <div>
                        <strong>{product?.productOverview?.productNumber[0] || " "}</strong>
                        <p className={styles.cardcategory}>{getLeafCategoryName(product?.categories) || " "}</p>
                      </div>
                      <div>
                        <span className={styles.cardviews}>{product?.totalProcured}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.cardCol2}>
            <div className={styles.card2}>
              <ProdTable
                product={product}
                limit={limit}
                page={page}
                setPage={setdashboardProductPage}
                itemsPerPage={itemsPerPage}
                start={start}
                end={end}
                totalItems={totalItems}
              />
            </div>
          </div>
        </div>

      </div>
    </div >
  )
}

export default Dashboard
